import React from "react";

const Contact: React.FC = () => {
  return (
    <section className="w-full flex items-center justify-center bg-white py-16 pb-32">
      <div className="container mx-auto flex flex-col md:flex-row items-center px-8 lg:px-20 max-w-6xl gap-16">
        {/* Left Image Section */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src="/images/Hanna/DSC09748-min.jpg"
            alt="Hanna Olsson"
            className="rounded-lg shadow-lg"
          />
        </div>

        {/* Right Text Section */}
        <div className="w-full md:w-1/2 text-left">
          <h2
            className="text-xl font-bold text-gray-800 mb-4"
            style={{ fontFamily: "'Bebas Neue', sans-serif" }}
          >
            Kontakta Oss
          </h2>
          <p
            className="text-lg text-gray-600 leading-relaxed mb-4"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            Hanna Olsson, en erfaren personlig tränare och coach sedan 2021,
            brinner för funktionell träning och att hjälpa andra att nå sina
            mål. Med en passion för CrossFit och mångsidig träning skapar hon
            inspirerande och effektiva träningspass för alla nivåer.
          </p>
          <p
            className="text-lg text-gray-600 leading-relaxed"
            style={{ fontFamily: "'IBM Plex Mono', monospace" }}
          >
            Tveka inte att höra av dig med frågor om träning eller massage. Vi
            ser fram emot att hjälpa dig att nå dina mål och välkomnar dig till
            Lada Basteskår!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
